import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=98ef6d6a&scoped=true&"
import script from "./radio.vue?vue&type=script&lang=js&"
export * from "./radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ef6d6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98ef6d6a')) {
      api.createRecord('98ef6d6a', component.options)
    } else {
      api.reload('98ef6d6a', component.options)
    }
    module.hot.accept("./radio.vue?vue&type=template&id=98ef6d6a&scoped=true&", function () {
      api.rerender('98ef6d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/radio.vue"
export default component.exports